"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedphoneandplus = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedphoneandplus` : '') + (description ? ` desc-brandedphoneandplus` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedphoneandplus"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedphoneandplus"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V56C36 58.2091 34.2091 60 32 60H4C1.79086 60 0 58.2091 0 56V4Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 6H34V50H2V6Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34 50V6C26.2222 20.1062 15.4276 31.9703 2 40.6382V50H34Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 3C15 2.44772 15.4477 2 16 2H24C24.5523 2 25 2.44772 25 3C25 3.55228 24.5523 4 24 4H16C15.4477 4 15 3.55228 15 3Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 57C19.1046 57 20 56.1046 20 55C20 53.8954 19.1046 53 18 53C16.8954 53 16 53.8954 16 55C16 56.1046 16.8954 57 18 57ZM18 58C19.6569 58 21 56.6569 21 55C21 53.3431 19.6569 52 18 52C16.3431 52 15 53.3431 15 55C15 56.6569 16.3431 58 18 58Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 40C23.5228 40 28 35.5228 28 30C28 24.4772 23.5228 20 18 20C12.4772 20 8 24.4772 8 30C8 35.5228 12.4772 40 18 40Z",
    fill: "#FFF5EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.9322 24.42C18.7113 24.4311 19.3519 24.9254 19.3534 25.528L19.3842 34.3307C19.3755 34.941 18.7412 35.4249 17.962 35.4215C17.1829 35.4104 16.5423 34.9161 16.5408 34.3136L16.51 25.5108C16.5187 24.9006 17.153 24.4167 17.9322 24.42Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.5123 29.962C12.5053 30.7585 13.0007 31.4145 13.6114 31.4095L22.4117 31.3934C23.0224 31.3988 23.5135 30.741 23.5128 29.9341C23.5197 29.1377 23.0244 28.4817 22.4137 28.4867L13.6133 28.5028C13.0027 28.4974 12.5115 29.1552 12.5123 29.962Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedphoneandplus;